import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b9dcf40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b9dcf40&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4b9dcf40&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9dcf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9dcf40')) {
      api.createRecord('4b9dcf40', component.options)
    } else {
      api.reload('4b9dcf40', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b9dcf40&scoped=true", function () {
      api.rerender('4b9dcf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImagePreview/index.vue"
export default component.exports